import { MenuButton } from "@headlessui/react";

interface Props {
    children: React.ReactNode;
    as?: 'div'|'button';
}

const DropdownTrigger = ({ as = "div", children }: Props) => {

    return (
        <MenuButton as={as} className="relative z-[31]">{children}</MenuButton>
    )

}

export default DropdownTrigger;
